import { render, staticRenderFns } from "./StarReview.vue?vue&type=template&id=59c3009a&"
import script from "./StarReview.vue?vue&type=script&lang=js&"
export * from "./StarReview.vue?vue&type=script&lang=js&"
import style0 from "./StarReview.vue?vue&type=style&index=0&id=59c3009a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports